import { Market, SelectionType, Selection } from "../../../data";

export type OddsFormatHelper = {
    ML: MLHelper,
    Outright: OutrightHelper
};

export type SelectionSliceLimits = {
    CurrenctSelectionCount: number,
    SliceToSelectionCount: number
};

export type MLHelper = {
    isRegular(market: Market): boolean,
    getOddName(selection: Selection, useOddTitle: boolean): string,
    getOddShortName(selection: Selection): string
};

export type OutrightHelper = {
    showViewAll(market: Market, mobileView:boolean): boolean,
    getOdds(market: Market, mobileView:boolean): Selection[],
    getOddsOrderClass(selections: Selection[]): string
};

const firstLevelLimitDesktopView: SelectionSliceLimits = {
    CurrenctSelectionCount: 5,
    SliceToSelectionCount: 3
};
const LimitMobileView: SelectionSliceLimits = {
    CurrenctSelectionCount: 5,
    SliceToSelectionCount: 3
};
const secondLevelLimitDesktopView: SelectionSliceLimits = {
    CurrenctSelectionCount: 6,
    SliceToSelectionCount: 5
};

export const oddsFormatter: OddsFormatHelper = {
    ML: {
        /* Regular ML is when there is winner, draw, loser
        Otherwise there is no draw(tennis) */
        isRegular(market: Market): boolean {
            if (market.type !== SelectionType.ML) {
                throw "market is not ML";
            }

            return market.selections.length === 3;
        },
        getOddName(selection: Selection, useOddTitle: boolean): string {
            /* istanbul ignore next */
            if (useOddTitle) {
                return selection.title;
            }

            return this.getOddShortName(selection);
        },
        /* ML odd names should be "1", "X", "2" and last symbol of the selection id is used.
            E.g. 0ML25976039_1, 0ML25976039_2, 0ML25976039_3 */
        getOddShortName(selection: Selection): string {
            let selectionType: string = selection.id[selection.id.length - 1];

            switch (selectionType) {
                case "1":
                    return selection.isSwapped
                        ? "2"
                        : "1";
                case "2":
                    return "X";
                case "3":
                    return selection.isSwapped
                        ? "1"
                        : "2";
                default:
                    throw Error("selection is not ML");
            }
        }
    },
    Outright: {
        showViewAll(market: Market, mobileView: boolean): boolean {
            let minOddsCount:number = firstLevelLimitDesktopView.CurrenctSelectionCount;

            if (market.selections.length >= minOddsCount) {
                return true;
            }

            return false;
        },

        getOdds(market: Market, mobileView:boolean): Selection[] {
            if (market.type !== SelectionType.QA) {
                throw "market is not Outright";
            }

            let firstLevelLimits:SelectionSliceLimits = mobileView ?
            LimitMobileView : firstLevelLimitDesktopView;
            let secondLevelLimits:SelectionSliceLimits = mobileView ?
            LimitMobileView : secondLevelLimitDesktopView;

            if (market.selections.length === firstLevelLimits.CurrenctSelectionCount) {
                return market.selections.slice(0, firstLevelLimits.SliceToSelectionCount);
            } else if (market.selections.length >= secondLevelLimits.CurrenctSelectionCount) {
                return market.selections.slice(0, secondLevelLimits.SliceToSelectionCount);
            } else {
                return market.selections;
            }
        },

        getOddsOrderClass(selections: Selection[]): string {
            if (selections.length === 2 || selections.length === 3) {
                return "outright-single-column-buttons";
            }

            return "";
        }
    }
};